import axios from 'axios';

axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  validateStatus: false,
});
